'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'heart';
var width = 512;
var height = 512;
var aliases = [128153,128154,128155,128156,128420,129293,129294,129505,9829,10084,61578];
var unicode = 'f004';
var svgPathData = ['M32 165.1c0 36.4 15.9 70.5 35 100.7 22.2 35.1 52.4 69.5 83.4 100.1 30.9 30.5 62 56.5 85.3 75 7.7 6.1 14.5 11.3 20.2 15.5 5.7-4.3 12.5-9.5 20.2-15.5 23.4-18.4 54.4-44.5 85.3-75 31-30.6 61.2-65 83.4-100.1 19.2-30.2 35-64.3 35-100.7 0-55.9-45.3-101.1-101.1-101.1-32.5 0-62.9 15.6-81.9 41.9l-40.9 56.6-40.9-56.6C196.1 79.6 165.6 64 133.1 64 77.3 64 32 109.3 32 165.1z', 'M256 496S0 319.4 0 167.7C0 94.2 58.6 32 133.1 32 189.2 32 225.5 65.7 256 107.9 286.5 65.7 322.8 32 378.9 32 453.5 32 512 94.2 512 167.7 512 319.4 256 496 256 496zm0-333.5l-40.9-56.6c-19-26.3-49.5-41.9-81.9-41.9-55.9 0-101.1 45.3-101.1 101.1 0 36.4 15.9 70.5 35 100.7 22.2 35.1 52.4 69.5 83.4 100.1 30.9 30.5 62 56.5 85.3 75 7.7 6.1 14.5 11.3 20.2 15.5 5.7-4.3 12.5-9.5 20.2-15.5 23.4-18.4 54.4-44.5 85.3-75 31-30.6 61.2-65 83.4-100.1 19.2-30.2 35-64.3 35-100.7 0-55.9-45.3-101.1-101.1-101.1-32.5 0-62.9 15.6-81.9 41.9L256 162.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeart = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;